import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function outletAll() {
  const { data } = await axios.get(routes.ordersOutletAll, AXIOS_DEFAULT_CONFIG);
  return data;
}
